/**
 * Font configurations for word cloud
 * Ported from words_cloud_lib.coffee
 */

export const FONTS = [
  ['SaunaB', 'Sauna Bold', '1'],
  ['SegoeUIL', 'Segoe UI Light', '2'],
  ['Alfa Slab One', 'Alfa Slab One', '3'],
  ['Asul', 'Asul', '5'],
  ['Alegreya SC', 'Alegreya SC', '6'],
  ['IM Fell DW Pica SC', 'IM Fell DW Pica SC', '7'],
  ['Permanent Marker', 'Permanent Marker', '8'],
  ['Michroma', 'Michroma', '9'],
  ['Lobster', 'Lobster', 'a'],
  ['Frijole', 'Frijole', 'b'],
  ['Gloria Hallelujah', 'Gloria Hallelujah', 'c'],
  ['Amatic SC', 'Amatic SC', 'd'],
  ['Leckerli One', 'Leckerli One', 'e'],
  ['Six Caps', 'Six Caps', 'f'],
  ['Cinzel Decorative', 'Cinzel Decorative', 'g'],
  ['Berkshire Swash', 'Berkshire Swash', 'h'],
  ['Montserrat', 'Montserrat', 'j'],
  ['Merriweather', 'Merriweather', 'k'],
  ['Merriweather Sans', 'Merriweather Sans', 'l']
]

/**
 * Detect if a font is available in the browser
 * @param {string} fontFamily - Font family name to check
 * @returns {boolean}
 */
export function detectFont(fontFamily) {
  if (typeof document === 'undefined') return true

  const testString = 'mmmmmmmmmmlli'
  const testSize = '72px'
  const baseFonts = ['monospace', 'sans-serif', 'serif']

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  const getWidth = font => {
    context.font = `${testSize} ${font}`
    return context.measureText(testString).width
  }

  for (const baseFont of baseFonts) {
    const testFont = `${fontFamily}, ${baseFont}`
    if (getWidth(testFont) !== getWidth(baseFont)) return true
  }

  return false
}

/**
 * Preload a font by creating a temporary element
 * @param {string} fontFamily - Font family to preload
 * @returns {Promise<boolean>}
 */
export function preloadFont(fontFamily) {
  return new Promise(resolve => {
    if (detectFont(fontFamily)) {
      resolve(true)
      return
    }

    // Create a temporary element to trigger font loading
    const testEl = document.createElement('span')
    testEl.style.fontFamily = fontFamily
    testEl.style.fontSize = '0'
    testEl.style.visibility = 'hidden'
    testEl.textContent = 'test'
    document.body.appendChild(testEl)

    let attempts = 0
    const maxAttempts = 7

    const checkFont = () => {
      attempts++
      if (detectFont(fontFamily)) {
        document.body.removeChild(testEl)
        resolve(true)
      } else if (attempts < maxAttempts) {
        setTimeout(checkFont, 1000)
      } else {
        document.body.removeChild(testEl)
        resolve(false)
      }
    }

    setTimeout(checkFont, 100)
  })
}

export default {
  FONTS,
  detectFont,
  preloadFont
}
